<div class="bc-tab-options">
  <div class="tab-option" [ngClass]="getClass(tab.id)" *ngFor="let tab of data.tabs">
    <mat-icon>{{ tab.icon }}</mat-icon>
    <div class="product-name">
      {{ tab.name | translate }}
    </div>
    <div class="permission-option">
      <mat-select [value]="dropdownOptions[0].id" (selectionChange)="selectChange($event, tab.id, tab.name)">
        <mat-option *ngFor="let opt of dropdownOptions" [value]="opt.id">
          {{ opt.key | translate }}
        </mat-option>
      </mat-select>
    </div>
  </div>
</div>
